import { getSituacaoIptu } from "../services/api";

const SITUACOES_SEM_DEBITO = ["Não consta", "Imune", "Isento", "Cancelado", "Pago"];

export async function imobiliarioPossuiDebitosAbertos(
  municipio: string,
  idImobiliario: string | number
): Promise<boolean> {
  try {
    const data = await getSituacaoIptu({
      municipio,
      id_imobiliario: [Number(idImobiliario)],
    });

    if (!data.length) {
      return false;
    }

    return !SITUACOES_SEM_DEBITO.includes(data[0].situacao_iptu);
  } catch {
    return false;
  }
}
